
export enum ManagementSoftware {
  None = 0,
  Storedge = 1,
  Sitelink = 2,
  EasyStorage = 3,
  Syrasoft = 7,
  Hummingbird = 8,
  StorageCommander = 9,
  WebSelfStorage = 10,
  SelfStorageManager = 11,
  Storage360 = 12
}
